// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Material UI ( mui ) components
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

// Section for import custom components --------------------------------------------------------------------------------
import MansionItem from '@components/common/MansionList/MansionItem';

// Section for import custom types -------------------------------------------------------------------------------------
import { MansionData } from '@/types/api/mansionestates';

// Section for render component ----------------------------------------------------------------------------------------
export default function MansionList(props: MansionData): React.JSX.Element {
  const { results } = props;

  return (
    <Box>
      <ImageList
        sx={{ overflowX: 'scroll' }}
        className="mansionListScrollmbar w-full flex gap-x-6 max-md:gap-x-4 p-1 m-[-4px]"
      >
        {results.map((mansion) => (
          <ImageListItem key={mansion.id}>
            <MansionItem data={mansion} />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
}
